export var TemplateKind;
(function (TemplateKind) {
    TemplateKind["Static"] = "Static";
    TemplateKind["Modal"] = "Modal";
    TemplateKind["Slider"] = "Slider";
    TemplateKind["Mobile"] = "Mobile";
    TemplateKind["Comparer"] = "Comparer";
})(TemplateKind || (TemplateKind = {}));
